import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { Combobox, type ComboboxProps } from '@/components/controls';

export type FormComboboxProps = Omit<
  ComboboxProps,
  'selectedOption' | 'setSelectedOption'
> & {
  control?: Control;
};

export const FormCombobox = ({
  name,
  control,
  ...props
}: FormComboboxProps) => {
  return (
    <Controller
      name={name as string}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <Combobox
            {...props}
            selectedOption={value}
            setSelectedOption={onChange}
          />
        );
      }}
    />
  );
};

FormCombobox.displayName = 'Form.Combobox';

export const required = (
  message = 'The field is required',
  defaultValue = { id: '', value: null },
) => {
  return z
    .object({
      id: z.string().min(1, { message }),
      value: z.string().nullable(),
    })
    .catchall(z.any())
    .default(defaultValue)
    .refine((value) => value.id !== '', {
      message,
    });
};

FormCombobox.rules = { required };
